<template>
    <edit></edit>
</template>

<script>
    import edit from './activity_bargain_edit.vue'

    export default {
        name: 'activity_bargain_add',

        components: {
            edit
        }
    }
</script>